import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Input from "../Input";
import Button from "../Button";
import { ASSETS } from "../../utils/config";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import TextView from "../TextView";
import { useSendPhoneOtp } from "../../services/mutations";

const Wrapper = styled.div`
  padding: 28px;
`;

const Heading = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 18px;
  margin-left: 40%;
  padding-top: 0px;
`;

export default function AlertDialog({
  open,
  onClose,
  otp,
  setOtp,
  onSubmit,
  onResend,
}) {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Wrapper>
          <Heading>
            <img src={ASSETS.sms} style={{ marginRight: 8 }} />
            <TextView variant="title">Change Number</TextView>
            <CloseIcon
              onClick={onClose}
              style={{ position: "absolute", right: 24, cursor: "pointer" }}
            />
          </Heading>

          <DialogContent style={{ padding: 0 }}>
            <TextView variant="subtitle" style={{ marginBottom: 10 }}>
              Enter the OTP you received via text message on your phone
            </TextView>

            <Input
              placeholder="Enter OTP"
              maxLength={6}
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </DialogContent>

          <ButtonWrapper>
            <Button variant="secondary" onClick={onResend}>
              Resend
            </Button>
            <Button onClick={onSubmit} autoFocus disabled={otp.length !== 6}>
              Confirm
            </Button>
          </ButtonWrapper>
        </Wrapper>
      </Dialog>
    </React.Fragment>
  );
}
